export default "__VITE_ASSET__IFOt1MSe__"